import 'react-polymer';
import React from 'react';
// import { NavLink } from 'react-router-dom';
import NavLinkScrollTop from './NavLinkScrollTop';
import localize from './localize';

export default localize('navigation')(({ i18n }) => (
	<div className="nav-bar-container">
	  <q-nav justify="full" >
	    <NavLinkScrollTop exact to="/">{i18n.t('results')}</NavLinkScrollTop>
	    <NavLinkScrollTop to="/steps">{i18n.t('steps')}</NavLinkScrollTop>
	    <NavLinkScrollTop to="/lag">{i18n.t('lag')}</NavLinkScrollTop>
	    <NavLinkScrollTop to="/faq">{i18n.t('faq')}</NavLinkScrollTop>
	  </q-nav>
	</div>
));



// WEBPACK FOOTER //
// ./src/components/NavBar.js